import {
  Alert,
  AlertIcon,
  Box,
  Button,
  Flex,
  Input,
  Switch,
  Text,
  useTheme,
} from "@chakra-ui/react";
import React from "react";
import { Theme } from "../../theme";
import { useNavigate } from "react-router-dom";
import getAxios from "../../hooks/useAxios";
import Cookies from "js-cookie";
import { FaArrowRight } from "react-icons/fa";

const ModifyIncentivePayouts = () => {
  const theme = useTheme<Theme>();
  const navigate = useNavigate();

  const axios = getAxios();
  const access_token = Cookies.get("x-admin-auth");
  const [isDataFetching, setIsDataFetching] = React.useState(true);

  const [incentive_5_rides_amount, setIncentive_5_rides_amount] =
    React.useState("");
  const [incentive_fast_pickup_amount, setIncentive_fast_pickup_amount] =
    React.useState("");
  const [incentive_peak_3_rides_amount, setIncentive_peak_3_rides_amount] =
    React.useState("");

  const [createStatus, setCreateStatus] = React.useState("");

  const getIncentivePricing = async () => {
    try {
      const res = await axios.get(`/incentives/amounts`, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      console.log("res ", res.data);
      setIncentive_5_rides_amount(res.data?.incentive_daily_rides_amount);
      setIncentive_fast_pickup_amount(res.data?.incentive_fast_pickup_amount);
      setIncentive_peak_3_rides_amount(res.data?.incentive_peak_hour_amount);
    } catch (error) {
      console.log(error);
    } finally {
      setIsDataFetching(false);
    }
  };

  const handleModifyPayoutAmout = async (e: React.BaseSyntheticEvent) => {
    e.preventDefault();
    const data = {
      incentive_daily_rides_amount: Number(incentive_5_rides_amount),
      incentive_fast_pickup_amount: Number(incentive_fast_pickup_amount),
      incentive_peak_hour_amount: Number(incentive_peak_3_rides_amount),
    };

    try {
      const res = await axios.put(`/incentives/amounts`, data, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });
      setCreateStatus("created");
      console.log("submit", res);
      setTimeout(() => {
        navigate("/incentives");
      }, 2000);
    } catch (error) {
      console.log(error);
      setCreateStatus("error");
    }
  };

  React.useEffect(() => {
    getIncentivePricing();
  }, []);

  return (
    <Box style={{ padding: "2rem" }}>
      <Text
        sx={{
          fontSize: theme.fontSizes.subHeading2,
          marginBottom: theme.space["3xl"],
        }}
      >
        Update Incentive Payout Amount
      </Text>

      <Box
        style={{
          width: "50%",
          backgroundColor: "#FFFFFF",
          padding: "2rem",
          borderRadius: "8px",
        }}
      >
        <form onSubmit={handleModifyPayoutAmout}>
          <Flex flexDirection={"column"}>
            <label style={{ display: "block", marginTop: theme.space.xl }}>
              Daily Rides Incentive amount
            </label>
            <Input
              type="number"
              value={incentive_5_rides_amount}
              onChange={(e) => setIncentive_5_rides_amount(e.target.value)}
              name="incentive_5_rides_amount"
              placeholder="incentive_5_rides_amount"
              variant={"outline"}
            />

            <label style={{ display: "block", marginTop: theme.space.xl }}>
              Fast Pickup Incentive amount
            </label>
            <Input
              type="number"
              value={incentive_fast_pickup_amount}
              onChange={(e) => setIncentive_fast_pickup_amount(e.target.value)}
              name="incentive_fast_pickup_amount"
              placeholder="incentive_fast_pickup_amount"
              variant={"outline"}
            />

            <label style={{ display: "block", marginTop: theme.space.xl }}>
              Peak Hour Incentive amount
            </label>
            <Input
              type="number"
              value={incentive_peak_3_rides_amount}
              onChange={(e) => setIncentive_peak_3_rides_amount(e.target.value)}
              name="incentive_peak_3_rides_amount"
              placeholder="incentive_peak_3_rides_amount"
              variant={"outline"}
            />

            <Box sx={{ marginTop: theme.space.xxl }}>
              <Button
                type="submit"
                width="100%"
                height="3rem"
                rightIcon={<FaArrowRight />}
                isLoading={isDataFetching ? true : false}
                style={{
                  background: theme.colors.primary.main,
                  color: theme.colors.bg.main,
                }}
              >
                <Text sx={{ fontSize: theme.fontSizes.body }}>Update</Text>
              </Button>
            </Box>

            <Box sx={{ minHeight: "3.25rem" }}>
              {createStatus === "created" && (
                <Alert status="success">
                  <AlertIcon />
                  Payout amount updated successfully.
                </Alert>
              )}
              {createStatus === "error" && (
                <Alert status="error" borderRadius={"4px"}>
                  <AlertIcon />
                  Opps! Something went wrong.
                </Alert>
              )}
            </Box>
          </Flex>
        </form>
      </Box>
    </Box>
  );
};

export default ModifyIncentivePayouts;
